export enum CargoTempCategory {
    Inhibited = 1,
    HeatSensitive = 2,
    Cooled = 3,
    Heated = 4,
    NonHeat = 5,
}

export interface CargoInTankItem {
    cargoNumber: string;
    isOnBoard: boolean;
    tankId: number;
    tradeName: string;
    cargoTempCategory: CargoTempCategory;
    productId?: number;
    chartererName?: string;
}
